const STORAGE_KEY = "app_theme";
const THEMES = ["light", "dark"];

export function getTheme() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (THEMES.includes(saved)) {
    return saved;
  }
  return "light";
}

export function setTheme(theme) {
  const next = THEMES.includes(theme) ? theme : "light";
  document.documentElement.setAttribute("data-theme", next);
  localStorage.setItem(STORAGE_KEY, next);
  return next;
}

export function toggleTheme() {
  return setTheme(getTheme() === "dark" ? "light" : "dark");
}

export function initTheme() {
  return setTheme(getTheme());
}
